import { render, staticRenderFns } from "./PanelContact.vue?vue&type=template&id=a834bab0&"
import script from "./PanelContact.vue?vue&type=script&lang=js&"
export * from "./PanelContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports